<template>
  <section style="">
    <div v-if="page1Flag">
      <div class="key-row">
        <div
            v-for="(item, key) in viz1.viz_specific7.sub_data_sql"
            :key="key"
            class="key-item"
            @click="handleKeyClick(key)"
            :style="{ color: activeKey === key ? 'rgb(0, 105, 217)' : '' }"
        >
          {{ item.display_name }}
        </div>
      </div>
      <div class="salesDashboard">
<!--        <p class="firstLine">{{salesData[0].dim1_name}}</p>-->
        <div class="timePeriod">
          <p
              class="options"
              @click="updateTimePeriod('MTD')"
              :class="{ 'selected': selectedVal === 'MTD' }">
            MTD
          </p>
          <p
              class="options"
              @click="updateTimePeriod('QTD')"
              :class="{ 'selected': selectedVal === 'QTD' }">
            QTD
          </p>
          <p
              class="options"
              @click="updateTimePeriod('YTD')"
              :class="{ 'selected': selectedVal === 'YTD' }">
            YTD
          </p>
          <template v-if="isFirstDayOfMonth">
          <p
              class="options"
              @click="updateTimePeriod('PMTD')"
              :class="{ 'selected': selectedVal === 'PMTD' }">
            PMTD
          </p>
          <p
              class="options"
              @click="updateTimePeriod('PQTD')"
              :class="{ 'selected': selectedVal === 'PQTD' }">
            PQTD
          </p>
          <p
              class="options"
              @click="updateTimePeriod('PYTD')"
              :class="{ 'selected': selectedVal === 'PYTD' }">
            PYTD
          </p>
          </template>
          <!--      <img class="logo" src="@/assets/newCalendar.png" alt="calendar"/>-->
          <p class="options">
            <DatePicker
                v-model="dateRange"
                :class="{ 'selected': selectedVal === 'Date Range' }"
                :multiple="true"
                :confirm="true"
                :disabled-date="disableFutureDates"
                :show-input="false"
                :enable-time-picker="false"
                :clearable="false"
                :style="datepickerStyle"

            />
          </p>
          <div class="comment-button">
            <i class="fas fa-comment" @click="commentBox"></i>
          </div>
        </div>
        <b-modal id="comment-modal" title="Add Note" centered hide-footer @hidden="resetForm">
          <div class="popup-content">
            <b-form-group label="Note Type :">
              <b-form-select v-model="noteType" :options="noteOptions"></b-form-select>
            </b-form-group>

            <b-form-group label="Note :">
              <b-form-textarea v-model="noteDetails" rows="4" placeholder="Enter your note here..."></b-form-textarea>
            </b-form-group>

            <b-form-group label="Tagging">
              <b-form-radio-group
                  v-model="selectedTag"
                  :options="tagOptions"
                  name="tagging-radio"
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group label="Salesman Store Rating :">
              <div class="star-rating">
              <span
                  v-for="star in 5"
                  :key="star"
                  @click="setRating(star)"
                  class="star"
                  :class="{'selected': star <= currentRating}"
              >
                ★
              </span>
              </div>
            </b-form-group>

            <div class="text-right">
              <b-button size="sm" variant="primary" @click="onSubmit">Submit</b-button>
            </div>
          </div>
        </b-modal>
        <div class="schemaAndData">
          <div class="schema" v-if="selectedVal !=='Date Range'" data-range="false">
            <p class="label" style="text-align: center"> {{ selectedDisplayName }}</p>
            <p class="label">{{ getLabelsAndData().labels.cy }}</p>
            <p class="label">{{ getLabelsAndData().labels.ly }}</p>
            <p class="label">Growth%</p>
          </div>
          <div class="schema" v-if="selectedVal==='Date Range'" data-range="true">
            <p class="label" style="text-align: center"> {{ selectedDisplayName }}</p>
            <p class="label">{{ new Date(dateRange[0]).toLocaleDateString('en-GB') }} to
              {{ new Date(dateRange[dateRange.length - 1]).toLocaleDateString('en-GB') }}</p>
          </div>
          <div class="salesData">
            <div v-if="selectedVal !=='Date Range'">
              <div class="product" data-range="false"
                   @click="addRouteFunction(item.dim2_name)"
                   v-for="(item, index) in segregatedData"
                   :key="index">
                <p class="prod">
                  <img class="logo" src="@/assets/menu-bar.png" alt="more"/><span>{{ item.dim2_name }}</span>
                </p>
                <p class="numCompare">
                  {{ item.metric1 || 'NA' }}
                </p>
                <p class="numCompare">
                  {{ item.metric2 || 'NA' }}
                </p>
                <p class="perValue" v-if="item.metric3!=null">
                  <img v-if="(item.metric1-item.metric2)>0" src="@/assets/upward.png" alt="growth"/>
                  <img v-if="(item.metric1-item.metric2)<0" src="@/assets/downward.png" alt="growth"/>
                  {{ calculateGrowth(item.metric1,item.metric2) }}%
                </p>
                <p class="perValue" v-if="item.metric3 == null" :class="{'grey-text': !item[getLabelsAndData().dataKeys.growth]}">
                  NA
                </p>
              </div>
            </div>

            <div v-if="selectedVal==='Date Range'">
              <div class="product1" data-range="true"
                   @click="addRouteFunction(item.dim2_name)"
                   v-for="(item, index) in segregatedData"
                   :key="index">
                <p class="prod">{{ item.dim2_name }}</p>
                <p class="prod">{{ item.metric1 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="targetTracker">
        <div class="targetLabels">
          <p class="lab">{{ monthName.slice(0, 3) }} {{ year.toString().slice(-2) }}</p>
          <p class="lab">{{ getTargetLabels().labels.Target }}</p>
          <p class="lab">{{ getTargetLabels().labels.Achieved }}</p>
          <p class="lab">Achieved%</p>
        </div>
        <div class="productAndStats" v-for="(item, index) in segregatedData" :key="index">
          <p class="prodName"><span>{{ item.dim2_name }}</span></p>
          <div class="numbers">
            <P class="numOne" :class="{'grey-text': !item.metric4}">{{ item.metric4 || 'NA' }}</P>
            <P class="numTwo" :class="{'grey-text': !item.metric1}"> {{
                item.metric1 || 'NA'
              }}</P>
            <P class="perc"
               :class="{
                      'green-text': (item.metric1-item.metric4) > 0,
                      'red-text': (item.metric1-item.metric4) < 0,
              }"
            >
              {{ calAchievedPerc(item.metric4,item.metric1)}}%
            </P>
          </div>
        </div>
      </div>
      <div class="updateDate">
        <p>*Last updated on 22 Mar 2025 11:14:90 AM</p>
      </div>
    </div>
    <template v-else>
      <product-category ref="salesDashboard" :selected-data-sql="this.selectedDataSql" :viz1="viz1" :filters="filters"  :aggregated-data="segregatedData" :store-code="code" :selected-val="selectedVal" :sales-data="localSalesData" :page1-flag="page1Flag" @update:page1Flag="updatePage1Flag" :date-selected="dateRange"/>
    </template>
  </section>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import productCategory from "@/components/ProductCategory.vue";
import axios from "axios";

export default {
  name: "SalesDashboard",
  components: {DatePicker,productCategory},
  props: {
    salesData:[],
    viz1:Object,
    filters:Object
  },
  watch: {
    viz1:{
      immediate : true,
      deep: true,
      handler(newVal){
        if(newVal){
          this.activeKey =Object.keys(newVal.viz_specific7.sub_data_sql)[0];
        }
      }
    },
    salesData: {
      immediate: true, // Run immediately on component creation
      deep: true,     // Watch for nested changes if needed
      handler(newVal) {
        // Only update if we have new data
        if (newVal && newVal.length) {
          this.localSalesData = [...newVal];
        }
      }
    },
    dateRange(newRange) {
      if (newRange && newRange.length === 2) {
        this.selectedVal = 'Date Range';
        this.updateDatePickerStyle();
        this.getDateRange();
      }
    }
  },
  data: () => ({
    noteType: 'generic',
    noteDetails: '',
    currentRating: 0,
    noteOptions: [
      { value: 'generic', text: 'Generic' },
      { value: 'inventory', text: 'Inventory' },
      { value: 'about', text: 'About' },
      { value: 'store', text: 'Store' }
    ],
    selectedTag: null, // This will hold the selected value
    tagOptions: [
      { text: 'OnTrack', value: 'OnTrack' },
      { text: 'RedFlag', value: 'RedFlag' },
      { text: 'Validate', value: 'Validate' }
    ],
    // salesData: [],
    datepickerStyle: {
      '--dp-background-color': '#E4E5F9',
      '--dp-icon-color': '#083DB1',
    },
    selectedVal: 'MTD',
    dateRange: null,
    today: new Date(),
    year: new Date().getFullYear(),
    preYear: new Date().getFullYear() - 1,
    month: new Date().getMonth() + 1,
    monthName: new Intl.DateTimeFormat('en-US', {month: 'long'}).format(new Date()),
    page1Flag:true,
    code:"",
    activeKey:null,
    localSalesData: [], // Create local copy
    selectedDataSql:{},
    selectedDisplayName: 'Product', // default fallback
  }),
  computed: {
    isFirstDayOfMonth() {
      const today = new Date();
      console.log(today.getDate());
      return today.getDate() === 1; // Returns `true` only on the 1st day of the month
    },
    segregatedData() {

      switch (this.selectedVal) {
        case 'MTD': { // Added curly braces here
          const mtdData = this.localSalesData.filter(item => item.dim6_name === 'mtd');
          console.log(this.aggregateData(mtdData));
          console.log(this.localSalesData);
          return this.aggregateData(mtdData);
        } // Added curly braces here
        case 'QTD': { // Added curly braces here
          const qtdData = this.localSalesData.filter(item => item.dim6_name === 'qtd');
          console.log(this.aggregateData(qtdData));
          return this.aggregateData(qtdData);
        }
        case 'YTD': { // Added curly braces here
          const ytdData = this.localSalesData.filter(item => item.dim6_name === 'ytd');
          console.log(this.aggregateData(ytdData));
          return this.aggregateData(ytdData);
        }
        case 'PMTD': { // Added curly braces here
          const ytdData = this.localSalesData.filter(item => item.dim6_name === 'pmtd');
          console.log(this.aggregateData(ytdData));
          return this.aggregateData(ytdData);
        }
        case 'PQTD': { // Added curly braces here
          const ytdData = this.localSalesData.filter(item => item.dim6_name === 'pqtd');
          console.log(this.aggregateData(ytdData));
          return this.aggregateData(ytdData);
        }
        case 'PYTD': { // Added curly braces here
          const ytdData = this.localSalesData.filter(item => item.dim6_name === 'pytd');
          console.log(this.aggregateData(ytdData));
          return this.aggregateData(ytdData);
        }
        case 'Date Range':{
          return this.aggregateData(this.localSalesData)
        }
      }
      return [];
    },
  },
  methods: {
    calAchievedPerc(current,previous){
      const growth = ((previous - current) / current) * 100;
      return Math.abs(growth).toFixed(1);
    },
    onSubmit(){
      let submenuParam = this.$route.params.submenuId || "RDemo2"
      let allVizData = this.$store.state.fwConfigScreenElement.filter(m => m.menuId === submenuParam)
      let screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
      const payload={
        "noteType":this.noteType,
        "noteDetails":this.noteDetails,
        "rating":this.currentRating,
        "tag":this.selectedTag
      }
      const url = "/api/businessActions";
      const data = {
        userId: this.$store.state.userId,
        userName: this.$store.state.userName,
        menuName: screenName,
        screenletName: allVizData[0].screenletTitleDpName,
        vizletName: allVizData[0].vizletTitleDpName,
        recordIdentification: [submenuParam],
        annotation: '',
        tagStatus: this.selectedTag,
        assignedTo:'',
        bizInputValues: payload
      };
      console.log(payload,url,data);
      axios.post(url, data).then(
          ()=>{
            console.log('success');
          },
          (e) => {
            console.log("Post annotation", data)
            this.$commonFn.auditLog(screenName, allVizData[0].screenletTitleDpName, "", "POST", e);
            console.error("error in updating annotations", e);
          }
      )
      this.$bvModal.hide('comment-modal');
      this.resetForm();
    },
    resetForm() {
      this.noteType = 'generic'; // Reset to default value
      this.noteDetails = '';
      this.currentRating = 0;
      this.selectedTag = null
    },
    setRating(rating) {
      this.currentRating = rating;
    },
    commentBox(){
      this.$bvModal.show('comment-modal');
    },
    handleKeyClick(key) {
      this.activeKey = key;
      const selectedItem = this.viz1.viz_specific7.sub_data_sql[key];
      this.selectedDisplayName = selectedItem.display_name || 'Product';
      console.log(selectedItem);
      this.selectedDataSql = selectedItem
      var url = '/api/fetchDataWithParam/' + selectedItem.data_sql_id + '/' + 'CommonVizClass'
      axios.post(url, this.filters).then(resp => {
        console.log(resp);
        this.$set(this, 'localSalesData', resp.data)
      })
      this.dateRange = null
      this.selectedVal = this.selectedVal || 'MTD';
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === 'RDemo2')
      console.log("menuDetails",menuDetails);
      this.$commonFn.auditLog(menuDetails[0].syspk, 'RDemo2', menuDetails[0].menuName, menuDetails[0].menuName, "user-clk", "Success",this.$store.state.deviceType)
      // Handle your click logic here
    },
    calculateGrowth(current, previous) {
      if (!previous || previous === 0) return 'NA';
      const growth = ((current - previous) / previous) * 100;
      return Math.abs(growth).toFixed(1); // Absolute value for display
    },
    aggregateData(rawData) {
      // Create a map to store aggregated values
      const aggregatedMap = new Map();

      rawData.forEach(item => {
        // Create a unique key for each combination of dimensions
        const key = `${item.dim2_name}`;

        if (!aggregatedMap.has(key)) {
          // Initialize new entry if it doesn't exist
          aggregatedMap.set(key, {
            dim1_id : item.dim1_id,
            dim1_name: item.dim1_name,
            dim2_name: item.dim2_name,
            dim3_name: item.dim3_name,
            dim4_name: item.dim4_name,
            dim5_name: item.dim5_name,
            dim6_name: item.dim6_name,
            metric1: 0,
            metric2: 0,
            metric3: 0,
            metric4:0,
            metric5:0,
            metric6:0
          });
        }

        // Get the existing entry
        const entry = aggregatedMap.get(key);

        // Sum the metrics (convert strings to numbers first)
        entry.metric1 += Number(item.metric1) || 0;
        entry.metric2 += Number(item.metric2) || 0;
        entry.metric3 += Number(item.metric3) || 0;
        entry.metric4 += Number(item.metric4) || 0;
        entry.metric5 += Number(item.metric5) || 0;
        entry.metric6 += Number(item.metric6) || 0;
      });

      // Convert the map values to an array
      const result = Array.from(aggregatedMap.values());

      // Sort the result if needed (optional)
      result.sort((a, b) => {
        const nameA = a.dim2_name || '';
        const nameB = b.dim2_name || '';
        return nameA.localeCompare(nameB);
      });

      return result;
    },
    updateTimePeriod(val) {
      this.dateRange = null;
      console.log("salesData",this.salesData);
      this.selectedVal = val;
      if(val!=='Date Range'){
        this.$set(this, 'localSalesData', this.salesData);
      }
      // this.store.setSelectedTimePeriod(period);
      this.updateDatePickerStyle();
      console.log("selected time period:", this.selectedVal);
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === 'RDemo1')
      console.log("menuDetails",menuDetails);
      this.$commonFn.auditLog(menuDetails[0].syspk, 'RDemo1', menuDetails[0].menuName, menuDetails[0].menuName, "user-clk"+val, "Success",this.$store.state.deviceType)
    },
    updateDatePickerStyle() {
      if (this.selectedVal === 'Date Range') {
        this.datepickerStyle['--dp-background-color'] = '#083DB1';
        this.datepickerStyle['--dp-icon-color'] = 'white';
      } else {
        this.datepickerStyle['--dp-background-color'] = '#E4E5F9';
        this.datepickerStyle['--dp-icon-color'] = '#083DB1';
      }
    },
    disableFutureDates(date) {
      const today = new Date();
      return date > today;
    },
    getLabelsAndData() {
      const raw = this.viz1?.viz_specific7?.date_field_value;
      const baseDate = raw ? new Date(raw) : new Date();

      const year = baseDate.getFullYear();
      const month = baseDate.getMonth(); // 0–11
      const prevYear = year - 1;

      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const quarterAndYear = this.getFinancialQuarterAndYear(baseDate);

      let labels = {};
      let dataKeys = {};

      switch (this.selectedVal) {

          /* ================= MTD ================= */
        case 'MTD':
          labels = {
            cy: `${monthNames[month]} ${String(year).slice(-2)}`,
            ly: `${monthNames[(month - 1 + 12) % 12]} ${(month === 0 ? prevYear : year).toString().slice(-2)}`
          };
          dataKeys = { current: 'cmtd_qty', last: 'pmtd_qty', growth: 'mtd_growth_pct' };
          break;

          /* ================= QTD ================= */
        case 'QTD':
          labels = {
            cy: `Q${quarterAndYear.quarter} ${String(quarterAndYear.financialYear).slice(-2)}`,
            ly: `Q${quarterAndYear.quarter} ${String(quarterAndYear.financialYear - 1).slice(-2)}`
          };
          dataKeys = { current: 'cqtd_qty', last: 'pqtd_qty', growth: 'qtd_growth_pct' };
          break;

          /* ================= YTD ================= */
        case 'YTD':
          labels = {
            cy: `FY ${String(quarterAndYear.financialYear).slice(-2)}`,
            ly: `FY ${String(quarterAndYear.financialYear - 1).slice(-2)}`
          };
          dataKeys = { current: 'cytd_qty', last: 'pytd_qty', growth: 'ytd_growth_pct' };
          break;

          /* ================= PMTD ================= */
        case 'PMTD': {
          const prevMonthDate = new Date(year, month - 1, 1);
          const pmYear = prevMonthDate.getFullYear();
          const pmMonth = prevMonthDate.getMonth();

          labels = {
            cy: `${monthNames[pmMonth]} ${String(pmYear).slice(-2)}`,
            ly: `${monthNames[pmMonth]} ${String(pmYear - 1).slice(-2)}`
          };
          dataKeys = { current: 'cmtd_qty', last: 'pmtd_qty', growth: 'mtd_growth_pct' };
          break;
        }

          /* ================= PQTD ================= */
        case 'PQTD': {
          let pq = quarterAndYear.quarter - 1;
          let fy = quarterAndYear.financialYear;

          if (pq < 1) {
            pq = 4;
            fy -= 1;
          }

          labels = {
            cy: `Q${pq} ${String(fy).slice(-2)}`,
            ly: `Q${pq} ${String(fy - 1).slice(-2)}`
          };
          dataKeys = { current: 'cqtd_qty', last: 'pqtd_qty', growth: 'qtd_growth_pct' };
          break;
        }

          /* ================= PYTD ================= */
        case 'PYTD':
          labels = {
            cy: `FY ${String(quarterAndYear.financialYear - 1).slice(-2)}`,
            ly: `FY ${String(quarterAndYear.financialYear - 2).slice(-2)}`
          };
          dataKeys = { current: 'cytd_qty', last: 'pytd_qty', growth: 'ytd_growth_pct' };
          break;

          /* ================= DEFAULT ================= */
        default:
          labels = { cy: 'NA', ly: 'NA' };
          dataKeys = {};
      }

      return { labels, dataKeys };
    },


    getFinancialQuarterAndYear(date) {
      const today = new Date(date);
      const year = today.getFullYear();
      const month = today.getMonth() + 1; // Get month (1-12)

      let financialYear;
      let quarter;

      // Financial year starts in April
      if (month >= 4 && month <= 6) {
        quarter = 1;
        financialYear = year+1;
      } else if (month >= 7 && month <= 9) {
        quarter = 2;
        financialYear = year+1;
      } else if (month >= 10 && month <= 12) {
        quarter = 3;
        financialYear = year+1;
      } else { // Jan-Mar (Q4 of the previous financial year)
        quarter = 4;
        financialYear = year - 1; // Previous financial year
      }

      return {quarter, financialYear};
    },
    addRouteFunction(productName) {
      // store.setTypeOfProduct(productName);
      // this.page1Flag=false
      this.code = productName
      console.log("product name", productName)
      // this.$router.push('/product');
    },
    getTargetLabels() {
      let labels = {Target: 'Target', Achieved: 'Actual'};

      if (this.selectedVal) {
        labels = {Target: 'Target', Achieved: 'Actual'};
      }
      return {labels};
    },
    updatePage1Flag(newValue) {
      // Update the page1Flag prop
      this.page1Flag = newValue;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getDateRange() {
      const [fromDate, toDate] = this.dateRange;

      // Safely get the first dim2_name from sub_data_sql
      const firstDimName = this.viz1.viz_specific7.sub_data_sql
          ? Object.values(this.viz1.viz_specific7.sub_data_sql)[0]?.dim2_name
          : 'default_dim_name'; // Provide a fallback

      const payload = {
        DateConfig: {
          dateField: [this.viz1.viz_specific7?.dateField],
          dynamicField: ['&dynamic_col1'],
          dimensionField: [this.selectedDataSql?.dim2_name || firstDimName],
          dateRange: {
            fromDate: this.formatDate(fromDate),
            toDate: this.formatDate(toDate)
          }
        }
      };

      let passedParam = {...this.filters,...payload};

      // Safely get the date_range_sql_id
      const datasql = this.viz1.viz_specific7?.date_range_sql_id || 'default_sql_id';
      const url = '/api/fetchDataWithParam/' + datasql + '/' + 'CommonVizClass';

      axios.post(url, passedParam).then(resp => {
        this.$set(this, 'localSalesData', resp.data);
      }).catch(error => {
        console.error("API Error:", error);
      });
    }
  }
}
</script>
<style scoped>
.green-text {
  color: #4cd964 !important;
}

.red-text {
  color: red !important;
}

.grey-text {
  color: grey !important;
}

.star-rating {
  display: inline-flex;
  gap: 4px;
}

.star {
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
  //transition: all 0.2s;
  padding: 2px;
  border-radius: 50%;
}

.star.selected {
  color: gold;
  background: rgba(255, 215, 0, 0); /* Light gold background */
  //box-shadow: 0 0 8px rgba(255, 215, 0, 0.5);
}

.star:hover {
  transform: scale(1.2);
}

.comment-button {
  background: none;
  border: none;
  cursor: pointer;
  color: cornflowerblue; /* Adjust color to match your design */
  font-size: 1.2rem; /* Adjust size as needed */
  padding: 5px;
}

.key-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: center;
  align-items: center;
}

.key-item {
  padding: 4px 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  text-align: center;
  font-weight: 600;
  //flex: 1 0 auto;
}

.key-item:hover {
  color: rgb(0 105 217);
}

.salesDashboard {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  background-color: aliceblue;
  margin: 0 auto;
  border-radius: 30px;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

.firstLine {
  display: flex;
  padding: 5px 20px;
  justify-content: center;
  text-align: center;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 500;
  color: #083DB1;
  margin: 5px 0 10px;
  width: 100%;
}

.timePeriod {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.timePeriod img {
  width: 20px;
  height: 20px;
}

.options {
  display: flex;
  height: 36px;
  background-color: #E4E5F9;
  color: #083DB1;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
  font-size: clamp(12px, 3vw, 16px);
  //min-width: 70px;
  flex-grow: 1;
  max-width: 80px;
  transition: all 0.2s ease;
}

.options:hover {
  transform: scale(1.02);
}

.options.selected {
  background-color: #083DB1;
  color: white;
}

/* DatePicker specific styles */
.options .mx-datepicker {
  width: 100%;
  height: 100%;
}

.options .mx-input-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.options .mx-input {
  background: transparent;
  border: none;
  color: inherit;
  text-align: center;
  padding: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.options.selected .mx-input {
  color: white;
}

/* Schema and Data Section */
.schemaAndData {
  display: flex;
  flex-direction: column;
  border-top: 3px solid #3164f4;
  margin-bottom: 10px;
  width: 100%;
  //max-width: 500px;
}

.schema {
  display: grid;
  grid-template-columns: minmax(100px, 1.5fr) repeat(3, minmax(70px, 1fr));
  height: 45px;
  background-color: #083DB1;
  color: white;
  border-radius: 10px;
  margin-top: 8px;
  width: 100%;
  overflow: hidden;
}

.schema[data-range="true"] {
  grid-template-columns: minmax(80px, 1fr) minmax(150px, 3fr);
}

.label {
  display: flex;
  height: 100%;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  font-size: clamp(12px, 2.5vw, 16px);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.salesData {
  padding: 6px 0;
  background-color: white;
  border-radius: 10px;
  margin-top: -16px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.product1 {
  display: grid;
  grid-template-columns: minmax(100px,3fr) repeat(2, minmax(70px,1fr));
  min-height: 35px;
  cursor: pointer;
  border-radius: 10px;
  background-color: #E4E5F9;
  margin: 8px;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(8, 61, 177, 0.5);
  width: calc(100% - 16px);
}

.product {
  display: grid;
  grid-template-columns: minmax(100px, 1.5fr) repeat(3, minmax(70px, 1fr));
  min-height: 35px;
  cursor: pointer;
  border-radius: 10px;
  background-color: #E4E5F9;
  margin: 8px;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(8, 61, 177, 0.5);
  width: calc(100% - 16px);
}

.product[data-range="true"] {
  grid-template-columns: minmax(80px, 1fr) minmax(150px, 3fr);
}

.product:hover {
  transform: scale(1.01);
  box-shadow: 0 8px 15px rgba(8, 61, 177, 0.5);
}

.product:active {
  transform: scale(0.98);
}

.prod {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 10px;
  font-size: clamp(12px, 3vw, 14px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.prod span {
  display: inline-block;
  max-width: 100%;
  overflow: visible;
  white-space: normal; /* Allows text to wrap */
  word-break: break-word; /* Breaks long words */
}

.prod img.logo {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  flex-shrink: 0;
}

.numCompare{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  font-size: clamp(14px, 3vw, 16px);
  white-space: nowrap;
  overflow: hidden;
  color: #083DB1;
  text-overflow: ellipsis;
}

.perValue {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  font-size: clamp(14px, 3vw, 16px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.perValue img {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.grey-text {
  color: grey;
}

/* Responsive adjustments for very small screens */
@media (max-width: 400px) {
  .prod img.logo {
    width: 10px;
    height: 10px;
    margin-right: 2px;
    flex-shrink: 0;
  }

  .timePeriod {
    gap: 5px;
  }

  .options {
    min-width: 60px;
    height: 32px;
    font-size: 12px;
  }

  .schema, .product {
    grid-template-columns: minmax(100px, 1fr) repeat(3, minmax(50px, 1fr));
  }

  .product1{
    grid-template-columns: minmax(70px,2fr) repeat(2, minmax(50px,1fr));
  }

  .schema[data-range="true"],
  .product[data-range="true"] {
    grid-template-columns: minmax(70px, 1fr) minmax(120px, 3fr);
  }

  .label, .prod, .numCompare, .perValue {
    font-size: 12px;
  }
}


.targetTracker {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  background-color: #f2f2f2;
  border-radius: 10px;
  margin: 2px auto;
  padding: 5px;
  box-sizing: border-box;
}

.targetLabels {
  display: grid;
  grid-template-columns: minmax(100px, 1.5fr) repeat(3, minmax(70px, 1fr));
  /* Increased first column min-width */
  gap: 10px;
  margin-top: 2px;
  width: 100%;
  padding: 0 2px;
}

.lab {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: clamp(12px, 3vw, 16px);
  color: black;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
}

.productAndStats {
  display: grid;
  grid-template-columns: minmax(100px, 1.5fr) repeat(3, minmax(70px, 1fr));
  /* Increased first column min-width */
  gap: 10px;
  width: 100%;
  //padding: 5px 10px;
  align-items: center;
}

.prodName {
  display: flex;
  min-height: 36px;
  font-size: clamp(12px, 3vw, 4px);
  color: white;
  background-color: #083DB1;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  white-space: nowrap;
  overflow: visible; /* Changed from hidden to visible */
  text-overflow: clip; /* Changed from ellipsis to clip */
  min-width: 0; /* Allows text to overflow container */
}

/* Add word-breaking for long product names */
.prodName span {
  display: inline-block;
  max-width: 100%;
  overflow: visible;
  white-space: normal; /* Allows text to wrap */
  word-break: break-word; /* Breaks long words */
}

.numbers {
  display: contents; /* Children will participate in the grid */
}

.numOne, .numTwo, .perc {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: clamp(12px, 3vw, 16px);
  height: 30px;
  background-color: white;
  border-radius: 8px;
  padding: 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 60px;
}

.numOne, .numTwo {
  color: #083DB1;
}


.updateDate {
  margin: 10px auto 0;
  text-align: center;
  width: 100%;
  color: gray;
  font-size: clamp(12px, 2.5vw, 14px);
  padding: 0 10px;
}

@media (max-width: 600px) {
  .targetLabels, .productAndStats {
    grid-template-columns: minmax(0px, 1.5fr) repeat(3, minmax(60px, 1fr));
  }
}

/* Responsive adjustments for very small screens */
@media (max-width: 400px) {
  .targetLabels, .productAndStats {
    grid-template-columns: minmax(0px, 1.5fr) repeat(3, minmax(50px, 1fr));
    gap: 5px;
  }

  .lab, .prodName, .numOne, .numTwo, .perc {
    font-size: 12px;
  }

  .prodName {
    min-height: 32px;
    padding: 0 8px;
    white-space: normal; /* Allow wrapping on very small screens */
  }

}

</style>
